import inventoryUpdateFullcont from './inventoryUpdate-fullcont.html'

const fullcontEntity  = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const fullcontForm    = require('../../../../../components/fullcont/fullcont-form')
const fullcont        = require('../../../../../components/fullcont/fullcont')

const {formCopy}          = require('./inventoryUpdate-fullcont-form')
const {form}              = require('./inventoryUpdate-fullcont-form')
const {inventoryUpdateMT} = require('./inventoryUpdate-fullcont-multitable')
const inventoryUpdateDialog = require('./inventoryUpdate-dialog')
const inventoryUpdateHandler = require('./inventoryUpdate-fullcont-handler')
const inventoryUpdateJumperHandler = require('./inventoryUpdate-fullcont-jumper-handler')
const inventoryUpdateQuickview = require('./inventoryUpdate-quickview')
const itemDt = require('../item/item-dt')

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false
//Keep Item and Inventory Update mutually visible without clearing either fullcont state.
var inventoryUpdateActive = false
var pausedForItem          = false
var itemPausedForInventory = false

function HTMLselect(detail){

      fullcontHandler.HTMLselect(
            'inventoryUpdate', 'inventoryUpdate', 'inventoryUpdate-fullcont',
            inventoryUpdateFullcont, form, formCopy, inventoryUpdateMT,
            editDialog, undefined, undefined, htmlFc)

      htmlFc.selectOne = 'server/php/sql/inventoryUpdate.php'

      const itemPage = document.getElementById('item-page')

      if(itemPage !== null){
            itemPage.appendChild(htmlFc.fullcontHTML)
      }

      HTMLwasSelected  = true
}
/**/

export function start(detail){

      if(!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}
/**/

const obj = {

      cancelEdit:  { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)        }},
      confirmUpdate:{ start: (detail)=>{ confirmUpdate(detail)                            }},
      discard:     { start: (detail)=>{  discard(detail)                                  }},
      hide:        { start: (detail)=>{  hide(detail)                                     }},
      jumperToPurchase:{ start: (detail)=>{ inventoryUpdateJumperHandler.jumperToPurchase(detail, htmlFc) }},
      prepareEdit: { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)      }},
      selectOne:   { start: (detail)=>{  selectOne(detail)                               }},
      update:      { start: (detail)=>{  update(detail)                                  }},
      validateQty: { start: (detail)=>{  inventoryUpdateHandler.validateQty(detail, htmlFc) }},
      validateSellingPrice:{ start: (detail)=>{ inventoryUpdateHandler.validateSellingPrice(detail, htmlFc) }},

}
/**/

function selectOne(detail){

      detail.dbid   = '1'
      detail.entity = 'inventoryUpdate'

      fullcontEntity.selectOne(detail, htmlFc, afterSelectOne)
}

function afterSelectOne(){

      inventoryUpdateActive = true
      pausedForItem          = false
      pauseItemFullcont()
      fullcontHandler.prepareEdit({}, htmlFc)
      inventoryUpdateHandler.setReadonlyTooltips(htmlFc)
      inventoryUpdateHandler.setOriginalPlaceholders(htmlFc)
}

export function pauseForItem(){

      if(!inventoryUpdateActive || !HTMLwasSelected){ return }
      if(!htmlFc.fullcontHTML.classList.contains('fullcont-show')){ return }

      htmlFc.fullcontHTML.classList.remove('fullcont-show')
      pausedForItem          = true
      itemPausedForInventory = false
}

export function resumeAfterItem(){

      if(!inventoryUpdateActive || !pausedForItem || !HTMLwasSelected){ return true }

      const itemFullcont = document.getElementById('item-fullcont')

      if(itemFullcont?.classList.contains('fullcont-show')){ return false }

      htmlFc.fullcontHTML.classList.add('fullcont-show')
      pausedForItem = false
      return true
}

function pauseItemFullcont(){

      const itemFullcont = document.getElementById('item-fullcont')

      if(!itemFullcont?.classList.contains('fullcont-show')){ return }

      itemFullcont.classList.remove('fullcont-show')
      itemPausedForInventory = true
}

function resumeItemFullcont(){

      if(!itemPausedForInventory){ return }

      setTimeout(()=>{
            const itemFullcont = document.getElementById('item-fullcont')

            if(itemFullcont !== null){
                  itemFullcont.classList.add('fullcont-show')
            }

            itemPausedForInventory = false
      }, 300)
}

function hide(detail){

      // Lee los valores actuales del MT antes de decidir si hay cambios reales.
      fullcontForm.getValues(htmlFc)

      const inventoryTable = htmlFc.entityMT?.[0]
      const changedLines = inventoryTable === undefined
            ? []
            : inventoryUpdateHandler.getChangedLines(inventoryTable)

      if(changedLines.length > 0){
            editDialog()
            return
      }

      // Sin cambios en Qty o Selling Price, cierra sin pedir confirmacion.
      closeWithoutChanges()
}

function closeWithoutChanges(){

      inventoryUpdateActive = false
      pausedForItem          = false
      resumeItemFullcont()

      fullcontForm.clean(htmlFc)
      fullcontForm.cleanFromValues(htmlFc)

      fullcont.start({
            act:          'hide',
            id:           'inventoryUpdate-fullcont',
            fullcontHTML: htmlFc.fullcontHTML,
      })
}

function discard(detail){

      inventoryUpdateActive = false
      pausedForItem          = false
      resumeItemFullcont()
      fullcontHandler.discard(detail, htmlFc)
}

function update(detail){

      const exceededQuantityLines = inventoryUpdateHandler.getExceededQuantityLines(htmlFc)

      if(exceededQuantityLines.length > 0){
            inventoryUpdateQuickview.start({
                  act:   'show',
                  id:    'quantityError',
                  lines: exceededQuantityLines,
            })
            return
      }

      if(!inventoryUpdateHandler.validateUpdate(htmlFc)){ return }

      inventoryUpdateQuickview.start({
            act: 'show',
            id:  'confirmUpdate',
            lines: inventoryUpdateHandler.getChangedLines(htmlFc.entityMT[0]),
      })
}

function confirmUpdate(detail){

      inventoryUpdateHandler.update(htmlFc, ()=>{
            afterUpdate()
      })
}

function afterUpdate(){

      const itemFullcont     = document.getElementById('item-fullcont')
      const itemFullcontOpen = itemPausedForInventory || itemFullcont?.classList.contains('fullcont-show')

      inventoryUpdateActive = false
      pausedForItem          = false
      resumeItemFullcont()

      fullcontForm.clean(htmlFc)
      fullcontForm.cleanFromValues(htmlFc)

      fullcont.start({
            act:          'hide',
            id:           'inventoryUpdate-fullcont',
            fullcontHTML: htmlFc.fullcontHTML,
      })

      if(!itemFullcontOpen){
            itemDt.start({
                  dest:   'item',
                  elem:   'dt',
                  act:    'select',
                  entity: 'item',
            })
      }
}

//function to send
function editDialog(){

      inventoryUpdateDialog.start({
            act: 'show',
            id:  'discardChanges',
      })
}
